import type { Cin7Sale } from "@/api/dtos";
import type { Sale } from "@/api/sale/_models/Sale";
import {
  toSaleAddressFromCin7SaleAddress,
  toSaleOrderFromCin7SaleOrder,
} from "./utils";

export const toSaleFromCin7Sale = (dto: Cin7Sale): Sale => {
  return {
    id: dto.ID,
    customer: dto.Customer,
    customerId: dto.CustomerID,
    contact: dto.Contact,
    phone: dto.Phone,
    email: dto.Email,
    status: dto.Status,
    type: dto.Type,
    taxRule: dto.TaxRule,
    terms: dto.Terms,
    priceTier: dto.PriceTier,
    location: dto.Location,
    carrier: dto.Carrier,
    salesRepresentative: dto.SalesRepresentative,
    customerReference: dto.CustomerReference,
    note: dto.Note,
    baseCurrency: dto.BaseCurrency,
    customerCurrency: dto.CustomerCurrency,
    currencyRate: dto.CurrencyRate,
    billingAddress: toSaleAddressFromCin7SaleAddress(dto.BillingAddress),
    shippingAddress: toSaleAddressFromCin7SaleAddress(dto.ShippingAddress),
    order: toSaleOrderFromCin7SaleOrder(dto.Order),
    skipQuote: dto.SkipQuote,
    shipBy: dto.ShipBy,
    saleOrderDate: dto.SaleOrderDate,
    lastModifiedOn: dto.LastModifiedOn,
  };
};
